import React, { useContext } from 'react'
import { Title, Content } from '../styles/elements'
import FullPageAlert from '../views/FullPageAlert'
import PlanetsProgress from './PlanetsProgress'
import { PlanetBadge } from '../styles/planet'
import Image from '../styles/image'
import { LocaleContext } from '../routes'
import { setCookie, getCookie } from '../api/cookie'

export default ({ planetType, planets }) => {
  const locale = useContext(LocaleContext)
  const today = new Date().toLocaleDateString('fa-IR').split('/')
  const year = new Date().getFullYear()

  const persianMonth = today[1]

  let newSeason
  switch (persianMonth) {
    case '۱':
      newSeason = 'SPRING'
      break
    case '۴':
      newSeason = 'SUMMER'
      break
    case '۷':
      newSeason = 'AUTUMN'
      break
    case '۱۰':
      newSeason = 'WINTER'
      break
    default:
      newSeason = null
  }

  const isSeasonFirstDay = newSeason
  if (!isSeasonFirstDay) return <div />
  if (!planets || !Array.isArray(planets)) return <div />

  // const isSeasonAlertViewed = localStorage.getItem(`TAPSI-${newSeason}${year}`)
  const isSeasonAlertViewed = getCookie(`TAPSI-${newSeason}${year}`)

  const currentPlanet = planets.find(planet => planet.type === planetType)

  // const onClose = () => localStorage.setItem(`TAPSI-${newSeason}${year}`, true)
  const onClose = () => setCookie(`TAPSI-${newSeason}${year}`, true)

  return (
    !isSeasonAlertViewed &&
    <FullPageAlert
      headerImage={require(`../planets/${planetType.toLowerCase()}.jpg`)}
      buttonText="SUBMIT"
      hasCloseIcon={false}
      onClose={onClose}
    >
      <PlanetBadge>
        <Image src={require(`../planets/${currentPlanet.type.toLowerCase()}_era.png`)} width="79px" />
        <Title color="#fff">
          {currentPlanet.description.title}
        </Title>
      </PlanetBadge>
      <Title align="center">
        {locale.CURRENT_PLANET_MOTO[0]}&nbsp;
        {locale[newSeason]}&nbsp;
        {locale.CURRENT_PLANET_MOTO[1]}&nbsp;
        {locale[planetType]}&nbsp;
        {locale.CURRENT_PLANET_MOTO[2]}.
      </Title>
      <PlanetsProgress planetType={planetType} planets={planets} />
      <Content color="#4d4d4d" overflow="auto">
        {currentPlanet.description.text}
      </Content>
    </FullPageAlert>
  )
}
